import { normalizeOpportunityForBuilderPrompt } from "./opportunityBuilderNormalize";
import { generateBuilderPrompt } from "./generateBuilderPrompt";

export { normalizeOpportunityForBuilderPrompt, generateBuilderPrompt };

/**
 * MVP paste prompt for external AI app builders (Base44, Emergent, etc.).
 * Pipeline: normalize opportunity → builder-focused prompt (no Markdown #).
 *
 * @param {Record<string, any>} opportunity
 * @param {{ intel?: Record<string, any> | null }} [ctx]
 */
export function buildMvpShipPrompt(opportunity, ctx = {}) {
  const normalized = normalizeOpportunityForBuilderPrompt(opportunity, ctx);
  return generateBuilderPrompt(normalized);
}
